import {
  Component,
  Input,
  OnDestroy,
  TemplateRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalID } from '../../models/constants';
// Third Party
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';

// Services
import { SharedService } from '../../services/shared.service';
import { BoundBook } from '../../models/general';

@Component({
  selector: 'app-add-bound-book',
  standalone: true,
  templateUrl: './add-bound-book.component.html',
  styleUrl: './add-bound-book.component.scss',
  imports: [FormsModule],
})
export class AddBoundBookComponent implements OnDestroy {
  @ViewChild('yes_no_modal', { static: false }) yes_no_modal: TemplateRef<any>;

  @Input() context: any;
  header: string;
  optional_details: {};
  modal_id: number;
  boundbook_name: string;

  // Edit Mode
  isEdit: boolean = false;
  bookToEdit: any = null;

  modalRef: BsModalRef;
  modalConfig = {
    animated: true,
  };

  yn_options: ModalOptions = {
    class: 'modal-dialog, modal-dialog-centered',
    backdrop: 'static',
    ignoreBackdropClick: true,
    keyboard: false,
  };

  constructor(
    protected element: ElementRef,
    private modalService: BsModalService,
    private sharedService: SharedService,
  ) {}

  ngOnInit(): void {
    this.modal_id = this.modalService.config.id as number;
    if (this.isEdit && this.bookToEdit) {
      this.boundbook_name = this.bookToEdit.boundbook_name;
    }
  }

  // Closes the Modal
  closeModal() {
    this.modalService.hide(this.modal_id);
  }

  ngOnDestroy() {
    //    this.sub.unsubscribe();
  }
  async submitClick() {
    if (this.isEdit && this.bookToEdit) {
      await this.sharedService.renameBoundBook(
        this.bookToEdit.boundbook_id,
        this.boundbook_name,
      );
    } else {
      let new_boundbook: BoundBook = new BoundBook();
      new_boundbook.bound_book_name = this.boundbook_name;
      this.sharedService.addBoundBook(new_boundbook);
    }

    this.sharedService.closeModal(ModalID.add_bound_book);
  }
}
